import { defineMessages } from 'react-intl'

export default defineMessages({
  'upgrade.billed_monthly': {
    id: 'upgrade.billed_monthly',
    defaultMessage: 'Billed monthly',
  },
  'upgrade.billed_quarterly': {
    id: 'upgrade.billed_quarterly',
    defaultMessage: 'Billed {price} quarterly',
  },
  'upgrade.billed_twiceAYear': {
    id: 'upgrade.billed_twiceAYear',
    defaultMessage: 'Billed {price} twice yearly',
  },
  'upgrade.billed_yearly': {
    id: 'upgrade.billed_yearly',
    defaultMessage: 'Billed {price} yearly',
  },
  'upgrade.billed_everyOtherYear': {
    id: 'upgrade.billed_everyOtherYear',
    defaultMessage: 'Billed {price} every other year',
  },
  'upgrade.billed_first_month': {
    id: 'upgrade.billed_first_month',
    defaultMessage: 'First month {price}',
  },
  'upgrade.billed_first_quarter': {
    id: 'upgrade.billed_first_quarter',
    defaultMessage: 'First quarter {price}',
  },
  'upgrade.billed_first_half_year': {
    id: 'upgrade.billed_first_half_year',
    defaultMessage: 'First six months {price}',
  },
  'upgrade.billed_first_year': {
    id: 'upgrade.billed_first_year',
    defaultMessage: 'First year {price}',
  },
  'upgrade.billed_first_two_years': {
    id: 'upgrade.billed_first_two_years',
    defaultMessage: 'First two years {price}',
  },
})
